import React from 'react'
import asset4 from "../assets/asset4.svg"
import TitleSection from '../components/TitleSection'

const Overview2 = () => {
    const text = `توفر منصة سلامات مجموعة واسعة من المواد الدراسية، بما في ذلك الفيديوهات والدروس التفاعلية والمقالات، 
مما يسهل على المتعلمين الوصول إلى المعلومات التي يحتاجونها. كما تتيح ميزات تفاعلية مثل التعليقات والمناقشات، 
مما يتيح للمتعلمين تبادل الأفكار والاستفادة من تجارب الآخرين. وبالتالي يؤدي ذلك إلى تعزيز تجربة التعلم وتحقيق 
النجاح الأكاديمي والمهني من خلال توفير بيئة تعليمية مرنة وداعمة.`;

    return (
        <div
            dir="rtl"
            id="overview"
            className="flex flex-col-reverse md:flex-row items-center justify-between w-[90%] mx-auto  gap-10"
        >
            {/* Text Section */}
            <div className="w-full md:w-1/2">
                <TitleSection
                    title="كيف تساعدك منصة سلامات على النجاح!"
                    desc={text}
                />
            </div>

            {/* Image Section */}
            <div className="w-full md:w-1/3 flex justify-end">
                <img
                    src={asset4}
                    alt="لمحة عن المنصة"
                    className=" w-full h-auto rounded-2xl "
                />
            </div>
        </div>
    );
};

export default Overview2;
